export interface InfoCard {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

export const infoCards: InfoCard[] = [
  { title: 'features.feature1.title', description: 'features.feature1.description', imageSrc: '', imageAlt: '' },
  { title: 'features.feature2.title', description: 'features.feature2.description', imageSrc: '', imageAlt: '' },
  { title: 'features.feature3.title', description: 'features.feature3.description', imageSrc: '', imageAlt: '' },
  { title: 'features.feature4.title', description: 'features.feature4.description', imageSrc: '', imageAlt: '' },
  { title: 'features.feature5.title', description: 'features.feature5.description', imageSrc: '', imageAlt: '' },
  { title: 'features.feature6.title', description: 'features.feature6.description', imageSrc: '', imageAlt: '' },
];
